import QuoteProductPriceComponentViewModel from "./quoteProductPriceComponentViewModel";

export default class QuoteViewModelProductPricingViewModel {
    constructor(item){
        if(item){
            this.baseComponent = new QuoteProductPriceComponentViewModel(item.baseComponent);
            this.subComponents = item.subComponents.map((x) => new QuoteProductPriceComponentViewModel(x));
            this.nonBaseComponents = item.nonBaseComponents.map((x) => new QuoteProductPriceComponentViewModel(x));
            this.dNetPrice = item.dNetPrice;
            this.msrp = item.msrp;
            this.originalDNetPrice = item.originalDNetPrice;
            this.unitPrice = item.unitPrice;
            this.unitMsrp = item.unitMsrp;
            this.totalPrice = item.totalPrice;
            this.totalMsrp = item.totalMsrp;
        }
    }
}
